<div class="col-12 btn-container d-flex align-items-center justify-content-center mt-4 mb-3">
    <!-- <sm-confirm [props]="btnProps.reset" [title]="'Confirm Reset'" [message]="'Are you sure you want to reset?'"
        (confirm)="reset(form)" [form]="form" (invalidFields)="showInvalidValues($event)"></sm-confirm> -->
    <sm-confirm [props]="btnProps.submit" [title]="'Confirm Submit'" [message]="'Are you sure you want to submit?'"
        (confirm)="submit(form)" [form]="form" (invalidFields)="showInvalidValues($event)"></sm-confirm>

</div>
<div class="row mb-3" *ngIf="invalidFields.length > 0">
    <span class="error-log text-danger">*Please enter {{ invalidFields }} before submitting the form</span>
</div>